<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    class="copy-icon"
    :style="{ '--icon-color': color }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#9333ea',
  },
})
</script>

<style scoped>
.copy-icon {
  display: inline-block;
  vertical-align: middle;
  transition: opacity 0.2s;
  color: var(--icon-color, #9333ea);
}

.copy-icon:hover {
  opacity: 0.8;
}
</style>

<style>
/* Make icon white when inside buttons */
a.btn-link .copy-icon,
a.btn-sm .copy-icon,
button.btn-sm .copy-icon,
button.btn-primary .copy-icon {
  color: white !important;
}
</style>
